module.exports = __webpack_public_path__ + "static/media/1_A1_17.37ae33e7.png";